import { Component, OnInit, forwardRef } from "@angular/core";
import { UserProvider } from "src/app/services/user/user";
import {
  IonicModule,
  ModalController,
  NavController,
  NavParams,
} from "@ionic/angular";
import { PrivacidadePage } from "../configuracao/privacidade/privacidade.page";
import { TermoUsoPage } from "../termo-uso/termo-uso.page";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ImagePipe } from "src/app/pipes/image/image";
import { TranslateModule } from "@ngx-translate/core";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
@Component({
  selector: "app-aceite-privacidade",
  templateUrl: "./aceite-privacidade.page.html",
  styleUrls: ["./aceite-privacidade.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    LoadingSpinnerComponent,
  ],
})
export class AceitePrivacidadePage implements OnInit {
  descricao = "";
  dependentes: any = [];
  tokenpush = "";
  loaded = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public nav: NavController,
    public userProvider: UserProvider
  ) {
    this.tokenpush = this.navParams.get("tokenpush");
    this.userProvider.getAceiteDescricao().subscribe({
      next: (result) => {
        this.descricao = result.documento;
        this.dependentes = result.dependentes;

        setTimeout(() => {
          this.loaded = true;
        }, 1000);
      },
      error: (err) => {
        console.error("Erro ao buscar a descrição:", err);
        this.loaded = true;
      },
    });
  }

  ngOnInit() {}

  politicas() {
    this.userProvider.getDados().then(async (result) => {
      const modalPage = await this.modalCtrl.create({
        component: PrivacidadePage,
        componentProps: { idInstituicao: result.instituicao.id },
      });
      modalPage.present();
    });
  }

  termos() {
    this.userProvider.getDados().then(async (result) => {
      const modalPage = await this.modalCtrl.create({
        component: TermoUsoPage,
        componentProps: { idInstituicao: result.instituicao.id },
      });
      modalPage.present();
    });
  }

  aceito() {
    this.userProvider.realizarAceite(this.tokenpush).subscribe((data) => {
      this.modalCtrl.dismiss();
    });
  }
}
